export enum ESeanceStatusIcon {
	canceled = "close",
	done = "checkmark",
	pending = "time",
	late = "warning",
	completed = "logoEuro"
}